module.exports = __webpack_public_path__ + "media/images/1-empty-fa2b40286e480b5f1138435fddd42b87.png";